import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "text-xl font-medium"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Sessioner for tema: ", -1)
const _hoisted_4 = { class: "font-semibold" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-lg leading-6 font-medium text-black" }, "Vedrørende disse tal"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm leading-5 text-gray-500" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Denne tabel viser hvor mange sessioner, der er fuldført, fravalgt og ikke nået til for det valgte tema."),
    /*#__PURE__*/_createElementVNode("p", null, "Denne information er ikke altid blevet opsamlet i appen. Det er derfor muligt, at denne tabel ikke stemmer overens med de andre tabeller og grafer på denne side.")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericTable = _resolveComponent("GenericTable")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    "close-button": "",
    size: "w-220",
    padding: "px-10 py-6"
  }, {
    toggle: _withCtx((state) => [
      _renderSlot(_ctx.$slots, "toggle", _normalizeProps(_guardReactiveProps(state)))
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", null, [
        (_ctx.selectedCourse)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_ctx.activeTheme?.title)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.activeTheme.title), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_GenericTable, {
                headers: _ctx.headers,
                items: _ctx.items
              }, null, 8, ["headers", "items"]),
              _hoisted_5
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }))
}